var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ticket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33301 6.66667C3.33301 6.22464 3.5086 5.80072 3.82116 5.48816C4.13372 5.17559 4.55765 5 4.99967 5H14.9997C15.4417 5 15.8656 5.17559 16.1782 5.48816C16.4907 5.80072 16.6663 6.22464 16.6663 6.66667V8.33333C16.2243 8.33333 15.8004 8.50893 15.4878 8.82149C15.1753 9.13405 14.9997 9.55797 14.9997 10C14.9997 10.442 15.1753 10.866 15.4878 11.1785C15.8004 11.4911 16.2243 11.6667 16.6663 11.6667V13.3333C16.6663 13.7754 16.4907 14.1993 16.1782 14.5118C15.8656 14.8244 15.4417 15 14.9997 15H4.99967C4.55765 15 4.13372 14.8244 3.82116 14.5118C3.5086 14.1993 3.33301 13.7754 3.33301 13.3333V11.6667C3.77504 11.6667 4.19896 11.4911 4.51152 11.1785C4.82408 10.866 4.99967 10.442 4.99967 10C4.99967 9.55797 4.82408 9.13405 4.51152 8.82149C4.19896 8.50893 3.77504 8.33333 3.33301 8.33333V6.66667Z",
    fill: "#18173C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/Ticket.377a2bccf8e0f1ff5323979b29654b85.svg";
export { ForwardRef as ReactComponent };